import React from 'react';

function About() {
    return <p>about</p>;
}

export default About;